import { render, staticRenderFns } from "./ClipVideoSkeleton.vue?vue&type=template&id=54f80794"
import script from "./ClipVideoSkeleton.vue?vue&type=script&lang=js"
export * from "./ClipVideoSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ClipVideoSkeleton.vue?vue&type=style&index=0&id=54f80794&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports